"use client";
import Section1 from "./section1";
import Section4 from "./section4";
import Ourwork from "./ourwork";
import ContractSection from "./contractSection";
import SectionWhyChooseUs from "./sectionWhyChooseUs";
import styles from "@/app/styles/content.module.scss";
import { useState, useEffect, useMemo } from "react";

export default function Content({ projects }) {
  // สถานะจาก hero (Section1) ว่ารูปหลักพร้อมหรือยัง
  const [heroReady, setHeroReady] = useState(false);

  // ให้สปินเนอร์อยู่ขั้นต่ำ 350ms กันแฟลช
  const [minDelayPassed, setMinDelayPassed] = useState(false);

  // เซฟตี้ 8s กันหน้าโดนล็อกถ้า asset ใดสะดุด
  const [safetyPassed, setSafetyPassed] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setMinDelayPassed(true), 500);
    const t2 = setTimeout(() => setSafetyPassed(true), 8000);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  // หน้าพร้อมเมื่อ hero พร้อม + ผ่าน min delay หรือผ่าน safety
  const pageReady = useMemo(
    () => (heroReady && minDelayPassed) || safetyPassed,
    [heroReady, minDelayPassed, safetyPassed]
  );

  return (
    <>
      <main
        className={styles.content}
        aria-busy={!pageReady}
        style={{ opacity: pageReady ? 1 : 0, transition: "opacity .3s ease" }}
      >
        {/* รับ onReady จาก Section1 เพื่อบอกว่า hero โหลดเสร็จ */}
        <Section1 onReady={() => setHeroReady(true)} />
        <Section4 />
        <SectionWhyChooseUs />
        <Ourwork projects={projects} />
        <ContractSection />
      </main>

      {/* สปินเนอร์เต็มหน้าจอทับไว้จนกว่าจะพร้อม */}
      {!pageReady && !projects && (
        <div className={styles.loaderOverlay}>
          <div className={styles.spinner} aria-label="Loading..." />
        </div>
      )}
    </>
  );
}
